<template>
  <div class="container superior">
    <div class="row">
      <div class="col">
        <h2 class="text-primary display-5 fw-bold text-start">{{ $t('general.politicaPrivacidad') }}</h2>
      </div>
    </div>
    <div
      v-for="(politica, index) in politicaPrivacidad"
      :key="politica.id"
      :class="['row question', { 'mt-4': index === 0 }]">
      <div
        class="title-header"
        :class="{ 'title-margin': !isCollapsed[politica.id] }"
        @click="toggleTerms(politica.id)">
        <div class="fw-semibold fs-4 text-primary">
          {{ politica.titulo }}
        </div>
        <div class="toggle-icon">
          <i
            :class="isCollapsed[politica.id] ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up'"
            class="text-primary"></i>
        </div>
      </div>
      <div v-show="!isCollapsed[politica.id]" class="terms-content">
        <div class="card card-body">
          <p v-sanitize-html="politica.descripcion" class="text-primary"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { agenciaStoreModule } from '@/store_pinia/agencia';
  import { computed, reactive, onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import { viajesGrupos } from '@/store_pinia/viajesGrupo';

  const agenciaStore = agenciaStoreModule();
  const viajesGruposStore = viajesGrupos();
  const route = useRoute();
  const isCollapsed = reactive({});

  const politicaPrivacidad = computed(() => {
    const viaje = viajeSeleccionado.value;
    const politicas = viaje?.politicaPrivacidad?.politicasPrivacidad || [];

    return politicas.length > 0 ? politicas : agenciaStore.getPoliticaPrivacidad?.politicasPrivacidad || [];
  });

  const viajeSeleccionado = computed(() => {
    return viajesGruposStore.getViajeSeleccionado;
  });

  function toggleTerms(id) {
    isCollapsed[id] = !isCollapsed[id];
  }

  onMounted(async () => {
    if (route.params.viajeId) {
      await viajesGruposStore.fetchViajeSeleccionado(route.params.viajeId);
    }
  });
</script>

<style scoped lang="scss">
  .title-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    border-radius: 0;
    color: var(--bs-primary);
    line-height: 30px;
    letter-spacing: 0.2px;
    padding: 1.2rem 2rem 1.2rem 2rem;
    position: relative;
    border: none;
    border-top: 1px solid rgba(var(--bs-primary-rgb), 0.3);
    width: 100%;
  }

  .title-margin {
    margin-bottom: 30px;
  }

  .toggle-icon {
    transition: transform 0.3s ease;
    font-size: 1.25rem;
  }

  .card-body {
    border: none;
    padding: 0 2rem 1.5rem 2rem;
  }

  .terms-content {
    animation: fadeIn 0.3s ease;
    width: 100%;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .row.question {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 1rem;
  }

  .superior {
    max-width: 1200px;
    margin: 0 auto;
    padding: 25px 0;
    padding-top: 11rem;
  }

  @media only screen and (max-width: 768px) {
    .title-header {
      padding: 1rem 1rem;
    }

    .toggle-icon {
      font-size: 1.1rem;
    }

    .superior {
      padding: 7rem 15px;
    }

    .card-body {
      padding: 0 1rem 1.5rem 1rem;
    }

    .fw-semibold.fs-4 {
      font-size: 1.2rem !important;
      line-height: 1.5;
    }
  }
</style>
